import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { NOSOTROS } from "./data";
import { History, Goal, Heart, Building2, ArrowRight } from "lucide-react";

const ICONS = { history: History, field: Goal, fans: Heart, infra: Building2 };

export const ClubIntro = () => (
  <section id="club" className="relative py-20 md:py-28 bg-[#eef1f7]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <Reveal className="lg:col-span-5">
          <span className="section-tag">El Club</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-navy leading-tight" style={{ fontFamily: "Outfit" }}>
            Más que un club, una comunidad
          </h2>
          <p className="mt-5 text-lg text-gray-600 leading-relaxed">{NOSOTROS.lead}</p>
          <Link
            to="/nosotros" data-testid="club-more"
            className="group mt-7 inline-flex items-center gap-2 text-navy font-semibold hover:text-gold transition-colors"
          >
            Conocé nuestra historia completa <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Reveal>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
          {NOSOTROS.blocks.map((b, i) => {
            const Icon = ICONS[b.icon] || History;
            return (
              <Reveal key={b.title} delay={(i % 2) * 0.08}>
                <div className="h-full bg-white rounded-2xl border border-gray-100 shadow-sm p-6 hover:-translate-y-1 hover:shadow-md transition-all">
                  <div className="h-11 w-11 rounded-xl bg-navy text-gold flex items-center justify-center">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="mt-4 text-lg font-bold text-navy" style={{ fontFamily: "Outfit" }}>{b.title}</h3>
                  <p className="mt-2 text-sm text-gray-600 leading-relaxed">{b.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
